module.exports = __webpack_public_path__ + "media/images/payment-method-3c560bc1.svg";